import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useQuery } from '@apollo/client'
import { TOP_VENUES } from '@graphql/venue/venue.query'
import { pageLoading } from '@shared/libs/allLoader'
import VenueLayout from './layout'
import NoData from '@shared/components/noData'

const TopVenue = dynamic(() => import('@shared/components/venueWidget/topVenue'))

function Venue({ input }) {
  const { data, loading } = useQuery(TOP_VENUES, {
    variables:
    {
      input: {
        nSkip: 0,
        nLimit: 10
      }
    }
  })

  if (loading) return pageLoading()

  const venueDetails = data?.getTopVenues || []
  return (
    <>
      <VenueLayout>
        {venueDetails.length === 0 ? <NoData title='This Venue’s a Ghost! Nothing here but tumbleweeds. Try another search to find your spot.' /> : <TopVenue venueData={venueDetails} />
        }
      </VenueLayout>
    </>
  )
}

Venue.propTypes = {
  input: PropTypes.object,
  venueDetails: PropTypes.array
}

export default Venue
